<template>
  <div>
    <input
      :value="value"
      @input="$emit('input', $event.target.value)"
      class="custom-input"
      :placeholder="placeholder"
    >
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [String, Number], default: undefined },
    placeholder: { type: String, default: 'Name/Email/Ethereum address/User ID' },
  },
}
</script>

<style lang="scss" scoped>
@import 'scss/variables';

.custom-input {
  -webkit-text-fill-color: $field-color-text; // autofill hack
  width: 90%;
  background: none;
  border: none;
  caret-color: $field-color-focused;
  color: $field-color-text;
  padding: $field-input-padding;

  @include material-border($field-color-focused, $field-color-unfocused);
}

</style>
